import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'
import { ComponentProps } from 'react'

type TProps = {
  title: string
  open: boolean
  handleCancel: () => void
  handleConfirm: () => void
  textContent?: string
  isWarning?: boolean
  children?: React.ReactNode
  isDisabled?: boolean
  confirmText?: string
  cancelText?: string
  confirmVariant?: ComponentProps<typeof Button>['variant']
  cancelVariant?: ComponentProps<typeof Button>['variant']
}

function ConfirmationDialog({
  title,
  open,
  handleCancel,
  handleConfirm,
  textContent = '',
  isWarning = false,
  children = null,
  isDisabled = false,
  confirmText = isWarning ? 'Proceed' : 'Yes',
  cancelText = isWarning ? 'Cancel' : 'No',
  confirmVariant = 'tertiary1',
  cancelVariant = 'tertiary1',
}: TProps) {
  return (
    <Dialog open={open} onClose={handleCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>{textContent}</Typography>
        {children}
      </DialogContent>

      <DialogActions>
        <Button
          onClick={handleCancel}
          variant={cancelVariant}
          disabled={isDisabled}
        >
          {cancelText}
        </Button>
        <Button
          onClick={handleConfirm}
          variant={confirmVariant}
          disabled={isDisabled}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
export default ConfirmationDialog
